/*
  Authored by Brett Barinaga on 11/17/21.
  Copyright (c) Kochava, Inc. All rights reserved.
*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as http from "../http";
import * as utils from "../utils/utils";
import { getPackageName } from "../browser/browser";
import { Log } from "../utils/log";
import { constructPayload } from "./payload";
import { DEFAULTS } from "../interfaces";
import { PersistKey, updatePersistedValue } from "../browser/persist";
var timeOut;
var canceled = false;
var build = function (instance) {
    var payload = constructPayload("init", instance);
    payload.build_date = instance.buildDate;
    payload.data = constructKvinitData(instance);
    Log.debug("Kvinit Payload", JSON.stringify(payload));
    return payload;
};
export var cancelRetries = function () {
    canceled = true;
    clearTimeout(timeOut);
};
export var send = function (instance, retryWaterfall, retries) {
    if (retries === void 0) { retries = 0; }
    return __awaiter(void 0, void 0, void 0, function () {
        var payload, success, resp, _loop_1, state_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    canceled = false;
                    payload = build(instance);
                    success = false;
                    _loop_1 = function () {
                        var sendTime, respStr, respTime, retryIndex, retrySec_1;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    Log.trace("Kvinit endpoint:", instance.kochavaConfig.networking.urls.init);
                                    sendTime = utils.getCurrTimeMS() - instance.startTimeMS;
                                    Log.diagDebug("Sending kvinit at ".concat(utils.formatTime(sendTime / 1000), " seconds"));
                                    return [4 /*yield*/, http.sendRequest(payload, (instance.overrideUrls.init) ?
                                            instance.overrideUrls.init : instance.kochavaConfig.networking.urls.init)];
                                case 1:
                                    respStr = _b.sent();
                                    respTime = utils.getCurrTimeMS() - instance.startTimeMS;
                                    Log.diagDebug("Completed kvinit at ".concat(utils.formatTime(respTime / 1000), "\n      seconds with a network duration of ").concat(utils.formatTime((respTime - sendTime) / 1000), " seconds"));
                                    if (canceled) {
                                        Log.trace("Can no longer retry kvinit, cancelling.");
                                        return [2 /*return*/, { value: false }];
                                    }
                                    try {
                                        resp = JSON.parse(respStr);
                                        Log.debug("Kvinit Response:", resp);
                                        success = http.wasRespSuccess(resp.success);
                                    }
                                    catch (e) {
                                        Log.error("Error parsing Kvinit Response", e);
                                        success = false;
                                    }
                                    if (success) {
                                        Log.info("Kvinit success!");
                                        updatePersistedValue(PersistKey.LastKvinit, JSON.stringify(resp), instance.useCookies);
                                        return [2 /*return*/, { value: success }];
                                    }
                                    if (!!canceled) return [3 /*break*/, 3];
                                    retryIndex = (retries > retryWaterfall.length - 1) ? retryWaterfall.length - 1 : retries;
                                    retrySec_1 = retryWaterfall[retryIndex];
                                    Log.error("Kvinit failed, attempting again in ".concat(retrySec_1, " seconds"));
                                    return [4 /*yield*/, new Promise(function (resolve) { timeOut = setTimeout(resolve, retrySec_1 * 1000); })];
                                case 2:
                                    _b.sent();
                                    retries++;
                                    _b.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    };
                    _a.label = 1;
                case 1: return [5 /*yield**/, _loop_1()];
                case 2:
                    state_1 = _a.sent();
                    if (typeof state_1 === "object")
                        return [2 /*return*/, state_1.value];
                    _a.label = 3;
                case 3:
                    if (!success && !canceled) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
};
export var applyKvinitResp = function (instance, resp) {
    if (resp.general) {
        if (resp.general.device_id_override) {
            Log.trace("Device_id override found, going from ".concat(instance.kochavaDeviceId, " to\n        ").concat(resp.general.device_id_override));
            instance.kochavaConfig.general.device_id_override = resp.general.device_id_override;
            instance.kochavaDeviceId = resp.general.device_id_override;
            updatePersistedValue(PersistKey.OverrideDeviceId, resp.general.device_id_override, instance.useCookies);
        }
        if (resp.general.app_id_override) {
            Log.trace("App_id override found, going from ".concat(instance.appGuid, " to\n        ").concat(resp.general.app_id_override));
            instance.kochavaConfig.general.app_id_override = resp.general.app_id_override;
            instance.appGuid = resp.general.app_id_override;
            updatePersistedValue(PersistKey.OverrideAppId, resp.general.app_id_override, instance.useCookies);
        }
    }
    if (resp.config) {
        instance.kochavaConfig.config = {
            init_token: resp.config.init_token || DEFAULTS.config.init_token,
            refresh_minimum: (resp.config.refresh_minimum !== undefined &&
                resp.config.refresh_minimum !== null) ? resp.config.refresh_minimum :
                DEFAULTS.config.refresh_minimum,
        };
    }
    if (resp.install) {
        if (resp.install.resend_id) {
            instance.kochavaConfig.install.resend_id = resp.install.resend_id;
        }
        instance.kochavaConfig.install.updates_enabled =
            resp.install.updates_enabled || DEFAULTS.install.updates_enabled;
    }
    if (resp.networking) {
        instance.kochavaConfig.networking.retry_waterfall =
            resp.networking.retry_waterfall || DEFAULTS.networking.retry_waterfall;
        instance.retryWaterfall =
            instance.kochavaConfig.networking.retry_waterfall;
        if (resp.networking.urls) {
            instance.kochavaConfig.networking.urls = {
                init: resp.networking.urls.init || DEFAULTS.networking.urls.init,
                install: resp.networking.urls.install || DEFAULTS.networking.urls.install,
                event: resp.networking.urls.event || DEFAULTS.networking.urls.event,
                identityLink: resp.networking.urls.identityLink || DEFAULTS.networking.urls.identityLink,
            };
        }
    }
    if (resp.privacy) {
        instance.kochavaConfig.privacy = {
            allow_custom_ids: resp.privacy.allow_custom_ids || DEFAULTS.privacy.allow_custom_ids,
            deny_datapoints: resp.privacy.deny_datapoints || DEFAULTS.privacy.deny_datapoints,
            deny_event_names: resp.privacy.deny_event_names || DEFAULTS.privacy.deny_event_names,
            deny_identity_links: resp.privacy.deny_identity_links || DEFAULTS.privacy.deny_identity_links,
        };
    }
};
var constructKvinitData = function (instance) {
    var currTime = Math.floor(Date.now() / 1000);
    var uptime = (currTime - instance.startTimeMS) / 1000;
    if (uptime < 0.0)
        uptime = 0.0;
    return {
        package: getPackageName(),
        platform: "web",
        starttime: instance.startTimeMS / 1000,
        uptime: uptime,
        usertime: currTime,
    };
};
